<ion-content class="container">
  <div class="tabs-container">
    <div class="card">
      <ion-row>
        <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)">
              <mat-tab label="demographicwise">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Demographic Wise</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="scoreexpwise">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Score & Exp. Wise</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Salary&LeaveWise">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Salary & Leave Wise</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10">
          <div class="center-content float-right"
            style="display: flex; align-items: center; justify-content: space-between;">

            <!-- Download Button -->
            <!-- <div>
              <button type="button" class="back_btn fs-14 center-content  mr-20" [matMenuTriggerFor]="menu"
                [style.border-color]="buttonColorName" [style.color]="buttonColorName" (click)="onClickDownloadBtn()">
                <span class="material-icons fs-20 mr-5">download</span>
                Download
                <span *ngIf="onDownDownlaodArrow" class="material-icons fs-20 ml-15">keyboard_arrow_down</span>
                <span *ngIf="onUpDownlaodArrow" class="material-icons fs-20 ml-15">keyboard_arrow_up</span>
              </button>
            </div> -->

            <!-- Logs -->
            <div class=" mr-20">
              <span class="cp fs-14 link font_regular center-content mr-20"  (click)="onClickLogs()">
                <img src="././assets/icon/logsIcon.svg"><u>Logs</u>
              </span>
            </div>
            <!-- Setup Button -->
            <div>
              <button type="button" class="add_btn fs-14 float-right center-content mr-5 ml-2"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup
              </button>
            </div>

          </div>
        </ion-col>

        <!-- Mat Menu -->
        <mat-menu class="mr-30 mt-10 w-100" #menu="matMenu" (closed)="onMenuClose()">
          <div class="pl-15 center-content">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div (click)="exportTableToPDF('attritionPdf')" class="fs-14 pt-10 cp">PDF</div>
                <div (click)="exportToPng('attritionPdf', 'attritionChart')" class="fs-14 pt-15 cp">PNG</div>
              </ion-col>
            </ion-row>
          </div>
        </mat-menu>

      </ion-row>
    </div>
  </div>
  <!-- <div>

    <mat-form-field class="mat-height40 w-100 mat-input-style">
      <mat-select placeholder="Select Month" [(ngModel)]="selectedMonth"
        (selectionChange)="onMonthChange($event)">
        <mat-option *ngFor="let month of filteredMonths" [value]="month.key">
          {{ month.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button (click)="getMonths()">button</button>
    <p>Previous Months Count: {{ previousMonthsCount }}</p>
    <p>Selected Month: {{ selectedMonthName }}</p>
    <p>Selected Month Key: {{ selectedMonth }}</p>

    
  </div> -->
  <div class="card  attritionTab">
    <div class="p-10" *ngIf="selectedTypeTabName=='demographicwise'">
      <app-attrition-demographic></app-attrition-demographic>
    </div>
    <div class="p-10" *ngIf="selectedTypeTabName=='scoreexpwise'">
      <app-attrition-score-exp-wise></app-attrition-score-exp-wise>
    </div>
    <div class="p-10" *ngIf="selectedTypeTabName=='Salary&LeaveWise'">
      <app-attrition-salary-leave-wise></app-attrition-salary-leave-wise>
    </div>
  </div>
</ion-content>